module.exports = __webpack_public_path__ + "img/add_serial.e8449195.webp";